import { render, staticRenderFns } from "./STextInput.vue?vue&type=template&id=06130b41"
import script from "./STextInput.vue?vue&type=script&lang=js"
export * from "./STextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports